var _ = require('lodash');
window.$ = window.jQuery = require('jquery');

$.ajaxSetup({
  headers: {
    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
  }
});

require ('sweetalert')
require('slick-carousel')

require('./sliders')
require('./contact')
require('./newsletter')


$('.click_services').click(function(){
  $('html, body').animate({
    scrollTop: $('.services').offset().top + 60
  }, 500);
})

/*===== MOBILE MENU SHOW & HIDDEN =====*/
const navMenu = document.getElementById('nav-menu'),
  toggleMenu = document.getElementById('nav-toggle'),
  closeMenu = document.getElementById('nav-close')

/*SHOW*/
toggleMenu.addEventListener('click', () => {
  navMenu.classList.add('show')
})

/*HIDDEN*/
closeMenu.addEventListener('click', () => {
  navMenu.classList.remove('show')
})

//OPEN MENU HEADER
document.addEventListener("click", (evt) =>{
  const menu = document.getElementById("menuD")
  const openMenu = document.getElementById("contextMenu")
  let target = evt.target

  do{
    if(target == menu){
      //alert("hola")
      openMenu.style.display = "flex"
      return;
    }
    target = target.parentNode
  }while(target){
    openMenu.style.display = "none"
    }
})

///////OPEN ACCORDION////////
let acc = document.getElementsByClassName('accTittle'),
  content = document.getElementsByClassName('accContent')

if (acc) {
  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener('click', function () {
      this.classList.toggle('rotated')
      let content = this.nextElementSibling
      content.classList.toggle('openedContent')
    })
  }
}
